import * as types from '../mutation-types'

export default {
	namespaced: true,

	state: {
		plan: [],
		myPlanActive: [],
		plannedTask: [],
		plannedTaskByProject: []
	},

	actions: {
		fetchAll ({ commit }) {
			return window.axios.get('/plans').then(({ data }) => { 
				commit(types.STORE_PLAN, data)
				return data
			})
		},
		
		fetchById ({ commit }, { id }) {
			return window.axios.get(`/Plans/CustomPlan/${id}`).then(({ data }) => {
				return data
			})
		}, 

		// get all
		fetchPlannedTaskByProject ({ commit }, { projectId }) {
			return window.axios.get(`Plans/PlannedTaskByProjectId/${projectId}`).then(({ data }) => {
				commit(types.STORE_PLANNED_TASKS_BY_PROJECTS, data)
				return data
			})
		},

		create ({ commit }, { startDate, endDate, isActive, userId }) {
			return window.axios.post('/plans', { startDate, endDate, isActive, userId }).then(({ data }) => {
				return data
			})
		},

		update ({ commit }, { id, startDate, endDate, isActive, userId }) {
			return window.axios.put(`/plans/${id}`, { startDate, endDate, isActive, userId }).then(({ data }) => {
				return data
			})
		},

		createTask ({ commit }, { planId, projectId, content, durationInMinute, taskNo, isDone, date }) {
			return window.axios.post('/Plans/PlannedTask', { planId, projectId, content, durationInMinute, taskNo, isDone, date }).then(({ data }) => {
				return data
			})
		},

		updateTask ({ commit }, { id, planId, projectId, content, durationInMinute, taskNo, isDone, date }) {
			return window.axios.put(`/Plans/PlannedTask/${id}`, { planId, projectId, content, durationInMinute, taskNo, isDone, date }).then(({ data }) => {
				return data
			})
		},

		fetchActivePlanForUser ({ commit }, { userId }) {
			return window.axios.get('/Plans/ActivePlans', { params: { userId } }).then(({ data }) => {
				commit(types.STORE_MY_PLAN_ACTIVE, data)
				return data
			})
		},
		
		fetchPlannedTask ({ commit }, { planId }) {
			return window.axios.get(`/Plans/PlannedTasksAccordingToPlanId/${planId}`).then(({ data }) => {
				commit(types.STORE_PLANNED_TASKS, data)
				return data
			})
		},

		fetchPlanBetweenTwoDate ({ commit }, { from, to }) {
			return window.axios.get('/Plans/BetweenDates', { params: { from, to } }).then(({ data }) => {
				return data
			})
		},

		deletePlannedTask ({ commit }, { id }) {
			return window.axios.delete(`/Plans/PlannedTask/${id}`)
		},

		fetchPlanByUser ({ commit }, { userId }) {
			return window.axios.get('/Plans/ActivePlans', { params: { userId } }).then(({ data }) => {
				return data
			})
		},

		changeStatusPlannedTask ({ commit }, { id, isDone }) {
			return window.axios.put(`/Plans/PlannedTask/ChangeStatus/${id}`, {}, { params: { isDone } }).then(({ data }) => {
				return data
			})
		}
	},

	mutations: {
		[types.STORE_PLAN] (state, plan) {
			state.plan = plan
		},

		[types.STORE_MY_PLAN_ACTIVE] (state, myPlanActive) {
			state.myPlanActive = myPlanActive
		},

		[types.STORE_PLANNED_TASKS] (state, plannedTask) {
			state.plannedTask = plannedTask
		},

		[types.STORE_PLANNED_TASKS_BY_PROJECTS] (state, plannedTaskByProject) {
			state.plannedTaskByProject = plannedTaskByProject
		}
	}
}
